import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { InputAutocomplete, InputType } from '../enums';
import { InputBaseComponent } from '../input-base/input-base.component';
import { Validators } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-textbox',
  templateUrl: './input-textbox.component.html',
  styleUrls: ['./input-textbox.component.scss'],
  providers: [{ provide: InputBaseComponent, useExisting: forwardRef(() => InputTextboxComponent) }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputTextboxComponent extends InputBaseComponent implements OnInit {

  @Input() public autocomplete: InputAutocomplete | string = InputAutocomplete.Off;
  @Input() public type: InputType | null = null;
  @Input() public placeholder: string = '';
  @Input() public suffix?: string | null;
  @Input() public suffixContainerClass?: string;
  @Input() public addPattern?: string;
  @Input() public showPasswordMeter: boolean = false;
  @Input() public passwordMeterLabel: string = 'password-strength';
  @Input() public capitalizeOnBlur: boolean = false;
  @Input() public autofocusInput: boolean = false;
  @Input() public autocapitalize?: 'none' | 'off' | 'sentences' | 'on' | 'words' | 'characters' | null;

  @Output() public readonly suffixClicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @ViewChild('inputElement') private inputElement?: ElementRef;

  public passwordVisible: boolean = false;

  constructor() {
    super();
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.addPattern) {
      this.control.addValidators(Validators.pattern(this.addPattern));
    }
    if (!this.type) {
      console.log('Textboxtype muss angegeben werden für ' + this.id);
    }
  }

  public focus(): void {
    if (this.inputElement) {
      const element = <HTMLInputElement>this.inputElement.nativeElement;
      element.focus();
      element.select();
    }
  }

  @HostListener('focusout')
  @HostListener('keyup.enter')
  public whenLeaving(): void {
    const val = this.control.value;
    if (this.capitalizeOnBlur && val) {
      const first = val.charAt(0);
      if (first === first.toLowerCase() && first !== first.toUpperCase()) {
        this.control.setValue(first.toUpperCase() + val.slice(1));
      }
    }
  }
}
